import { getPlatforms } from "@/api/platform/index";
import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IPlatform, IPlatformInput } from "@/interfaces/platform.interfaces";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class PlatformService {
  private baseUrl = "platform";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IPlatform>> {
    const response = await getPlatforms({
      pageNumber: pagination.pageNumber,
      pageSize: pagination.pageSize,
    });

    const paginatedResponse = {
      items: response.items,
      totalCount: response.totalCount,
      pageNumber: pagination.pageNumber,
      pageSize: pagination.pageSize,
      hasNextPage: response.hasNextPage,
      hasPreviousPage: response.hasPreviousPage,
    };

    return paginatedResponse;
  }

  async filter(
    filter: IFilter<IPlatform>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IPlatform>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async create(formData: IPlatformInput): Promise<IPlatform> {
    return await httpRequest.post(this.baseUrl, formData);
  }

  async getById(platformId: number): Promise<IPlatform> {
    const platform = await httpRequest.get(`${this.baseUrl}/${platformId}`);

    return platform;
  }

  async update(formData: IPlatformInput, platformId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${platformId}`, formData);
  }

  async delete(platformId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${platformId}`);
  }
}

const platformService = new PlatformService();
export default platformService;
